import React from 'react';
import { Box } from '@mui/material';
import { UserAccessTable } from 'modules/portalConfigurations/routingAccess/ui';

export const UserAccessTab = () => {
  return (
    <Box p={3}>
      <UserAccessTable />
    </Box>
  );
};
